export default "__VITE_ASSET__B8Tg67Cq__"